import * as React from 'react';
import { SVGProps } from 'react';

const IconCardsSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M7 1H1v6h6V1zm0 8H1v6h6V9zm2-8h6v6H9V1zm6 8H9v6h6V9z" />
  </svg>
);
export default IconCardsSizeS;
